import React, { Component, Fragment } from 'react';
import { action, computed, observable, reaction } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';
import moment from 'moment';
import { TREE_EVENT, INFO_EVENT } from 'shared/dictionaries/events';
import { MAX_DATE, MIN_DATE, DISPLAY_DATE_FORMAT, TRANSPORT_DATE_FORMAT } from 'shared/config/widget';

import Button from 'material-ui/Button';
import { DatePicker } from 'material-ui-pickers/src/DatePicker/DatePicker';
import DatepickerModal from 'shared/components/DatepickerModal';
import { ChevronLeft, ChevronRight, Calendar } from 'mdi-material-ui';

import withAppStore from 'decorators/withAppStore';

import styles from 'shared/styles/components/Datepicker';
import { Typography } from 'material-ui';

@withStyles(styles)
@withAppStore
@observer
export default class Datepicker extends Component {

  @observable isOpen = false;
  @observable value = moment();

  @computed
  get date() {
    return this.appStore.onDate;
  }
  set date(value) {
    this.appStore.onDate = value;
  }

  @computed
  get label() {
    const { isMobile } = this.props
    return this.date ? this.date.format(isMobile ? TRANSPORT_DATE_FORMAT : DISPLAY_DATE_FORMAT) : 'На дату';
  }

  componentWillMount() {
    this.initializeState();
    this.subscribeToStateChanges();
  }

  render() {
    const { classes, isMobile } = this.props;

    return (
      <Fragment>

        <Button
          disableFocusRipple
          className={ classes.button }
          onClick={ this.handleOpen }
        >
          <Calendar className={ classes.buttonIcon } /> 
          {!isMobile && <Typography> { this.label } </Typography>}
          {isMobile && <Typography variant='caption'> { this.label } </Typography>}
          
        </Button>

        <DatepickerModal
          open={ this.isOpen }
          onAccept={ this.handleAccept }
          onClose={ this.handleClose }
          onClear={ this.handleClear }
        >
          <DatePicker
            date={ this.value }
            onChange={ this.handleChange }
            disableFuture={ false }
            openToYearSelection={ !this.date }
            minDate={ MIN_DATE }
            maxDate={ MAX_DATE }
            leftArrowIcon={ <ChevronLeft /> }
            rightArrowIcon={ <ChevronRight /> }
            classes={ classes }
          />
        </DatepickerModal>

      </Fragment>
    );
  }

  @action.bound
  handleOpen() {
    this.isOpen = true;
  }

  @action.bound
  handleClose() {
    this.isOpen = false;
  }

  @action.bound
  handleChange(value) {
    this.value = value;
  }

  @action.bound
  handleAccept() {
    if (this.date !== this.value) {
      this.date = this.value;
      this.sendEvent();
    }
    this.handleClose();
  }

  @action.bound
  handleClear() {
    this.date = null;
    this.handleClose();
    this.sendEvent();
  }

  initializeState() {
    if (this.date) {
      this.value = this.date;
    }
  }

  subscribeToStateChanges() {
    reaction(
      () => this.appStore.queryParamsStore.queryParams.date,
      () => {
        if (!this.appStore.isLoading)
          this.appStore.dataStore.reload()
      }
    );
  }

  sendEvent() {
    const eventName = this.appStore.widgetKind === 'tree' ? TREE_EVENT.CHANGE_DATE : INFO_EVENT.CHANGE_DATE;
    const date = this.date ? this.date.format(TRANSPORT_DATE_FORMAT) : null;
    this.appStore.sendEvent(eventName, { date });
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/Datepicker.js